import React, { useState, useEffect, memo, useRef } from "react";
import { Link } from 'react-router-dom';
import { useMsal } from "@azure/msal-react";
import HttpHelper from '../service/httpService'

const Header = (props) => {

    const [dropdown, setDropdown] = useState(false);
    const [openMenu, setOpenMenu] = useState('close');
    const [stickyClass, setStickyClass] = useState('');
    const [menus, setMenus] = useState({});

    const { instance } = useMsal();

    const listenScrollEvent = (event) => {
        if (window.scrollY > 175) {
            return setStickyClass("is-sticky")
        } else if (window.scrollY < 175) {
            return setStickyClass("")
        }
    }
    let ref = useRef();

    const getFeatures = async () => {
        await HttpHelper.get("Website/GetKeyFeature").then((response) => {
            if (response.status === 200) {
                console.log(response.data);
            }
        }).catch((error) => {
            console.log(error)
        })
    }
    const getMenuData = async () => {
        await HttpHelper.get("website/GetMenuTree").then((response) => {
            if (response.status === 200) {
                setMenus(response.data);
            }
        }).catch((error) => {
            console.log(error)
        })
    }

    useEffect(() => {
        if (localStorage.getItem('MenuItems')) {
            setMenus(JSON.parse(localStorage.getItem('MenuItems')));
        } else {
            getMenuData();
        }
        window.addEventListener('scroll', listenScrollEvent);
        var addBodyDashboardClass = document.getElementsByTagName('body');
        if (addBodyDashboardClass[0].classList.contains('dashboardWrapperCustom')) {
            addBodyDashboardClass[0].classList.remove('dashboardWrapperCustom');
        }

        getFeatures();

        return () =>
            window.removeEventListener('scroll', listenScrollEvent);
    }, []);

    useEffect(() => {
        const handler = (event) => {
            if (dropdown && ref.current && !ref.current.contains(event.target)) {
                setDropdown(false);
            }
        };
        document.addEventListener("mousedown", handler);
        document.addEventListener("touchstart", handler);
        return () => {
            // Cleanup the event listener
            document.removeEventListener("mousedown", handler);
            document.removeEventListener("touchstart", handler);
        };
    }, [dropdown]);
    return (
        <>
            {/* // <!-- Header Section Start --> */}
            <div className={`header-section header-transparent sticky-header ${stickyClass} `} style={{
                backgroundColor: `${props.page === 'career' || props.page === 'career-details' ? '#030e22' : 'transparent'}`
            }}  >
                <div className="header-inner">
                    <div className="container-fluid position-relative">
                        <div className="row justify-content-between align-items-center">
                            <div className="col-auto order-0">
                                <div className="header-logo header-logo-trailboss">
                                    <Link to='/' onClick={() => {
                                        window.scrollTo(0, 0);
                                    }} >
                                        {stickyClass === '' ?
                                            <img src={process.env.PUBLIC_URL + '/assets/images/logo/logo_trailboss.png'} alt="No image found" /> :
                                            <img src={process.env.PUBLIC_URL + '/assets/images/logo/logo_trailboss.png'} alt="No image found" />
                                        }

                                    </Link>
                                </div>
                            </div>
                            {/* <!-- Header Logo End --> */}

                            {/* <!-- Header Main Menu Start --> */}
                            <div className="col-auto col-xl d-flex align-items-center justify-content-xl-end justify-content-end order-2 order-xl-1">
                                <div className="menu-column-area d-none d-xl-block position-static">
                                    <ul className="menus">
                                        {
                                            menus.length > 0 ? menus.map((menu, index) => {
                                                if (menu.isActive == true) {
                                                    if (menu.children.length === 0) {
                                                        return (
                                                            menu.externalLink === null || menu.externalLink === '' ?
                                                                <li key={index} className="menu-items" ><Link to={menu.page ? '/page?slug=' + menu.page.slug : '/'} > {menu.title} </Link> </li>
                                                                : <li className="menu-items"><Link to={menu.externalLink}> {menu.title} </Link> </li>
                                                        )
                                                    } else {
                                                        return (
                                                            <li key={index} className="menu-items">
                                                                <button type="button" aria-haspopup="true"
                                                                    id={"child_" + index}
                                                                    aria-expanded={
                                                                        dropdown ? "true" : "false"
                                                                    }
                                                                    data-toggle="dropdown"
                                                                    onClick={
                                                                        (e) => {
                                                                            if (e.currentTarget.nextSibling.classList.contains('show')) {
                                                                                e.currentTarget.nextSibling.classList.remove('show')
                                                                                e.currentTarget.nextSibling.classList.remove('hide')
                                                                            } else {
                                                                                var elems = document.querySelectorAll(".dropdown.show");
                                                                                [].forEach.call(elems, function (el) {
                                                                                    el.classList.remove("show");
                                                                                    el.classList.add("hide");
                                                                                });
                                                                                e.currentTarget.nextSibling.classList.add('show')
                                                                            }
                                                                        }
                                                                    }
                                                                >{menu.title}<span className="arrow"></span></button>
                                                                <ul aria-labelledby={"child_" + index} className={"dropdown  " + (dropdown == true ? "show" : "")}>
                                                                    {
                                                                        menu.children.map((child, key) => {
                                                                            if (child.isActive == true) {
                                                                                return (

                                                                                    child.externalLink == null || child.externalLink == '' ?
                                                                                        <li key={key} className="menu-items"><Link to={child.page ? '/page?slug=' + child.page.slug : '/'}> {child.title} </Link> </li>
                                                                                        : <li className="menu-items"><Link to={child.externalLink}> {child.title} </Link> </li>

                                                                                )
                                                                            }
                                                                        })
                                                                    }
                                                                </ul>
                                                            </li>
                                                        )
                                                    }
                                                }
                                            })
                                                : null
                                            //: <ul className="menus">
                                            //    <li className="menu-items"><Link to='/'>No Menu Found!  <b>Please Add Menu</b></Link></li>
                                            //</ul>
                                        }

                                        <li className="menu-items GSABanner"><Link to="http://www.gsaelibrary.gsa.gov/ElibMain/contractorInfo.do?contractNumber=GS-10F-0206R&contractorName=TRAILBOSS+ENTERPRISES%2C+INC.&executeQuery=YES" target="_blank"><img src={process.env.PUBLIC_URL + '/assets/images/gsa_advantage.png'} /></Link></li>
                                    </ul>
                                </div>
                                <div className="header-mobile-menu-toggle d-xl-none ml-sm-2" onClick={() => setOpenMenu('open')} >
                                    <button className="toggle">
                                        <i className="icon-top"></i>
                                        <i className="icon-middle"></i>
                                        <i className="icon-bottom"></i>
                                    </button>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
            <div id="site-main-mobile-menu" className={`site-main-mobile-menu ${openMenu === 'open' ? 'MobileMenuOpen' : ''} `}>
                <div className="site-main-mobile-menu-inner">
                    <div className="mobile-menu-header">
                        <div className="mobile-menu-logo">

                            <Link to='/'>
                                <img src={process.env.PUBLIC_URL + '/assets/images/logo/logo_trailboss.png'} alt="No image found" />
                            </Link>
                        </div>
                        <div className="mobile-menu-close" onClick={() => setOpenMenu('close')} >
                            <button className="toggle">
                                <i className="icon-top"></i>
                                <i className="icon-bottom"></i>
                            </button>
                        </div>
                    </div>
                    <div className="mobile-menu-content">
                        <nav className="site-mobile-menu">
                            <ul>
                                {
                                    menus.length > 0 ? menus.map((menu, index) => {
                                        if (menu.children.length === 0) {
                                            return (
                                                menu.externalLink === null || menu.externalLink === '' ?
                                                    <li key={index}><Link to={menu.page ? '/page?slug=' + menu.page.slug : '/'} > {menu.title} </Link> </li>
                                                    : <li><Link to={menu.externalLink}> {menu.title} </Link> </li>
                                            )
                                        } else {
                                            return (
                                                <li key={index}>
                                                    <a type="button" aria-haspopup="true"
                                                        id={"child_" + index}
                                                        aria-expanded={
                                                            dropdown ? "true" : "false"
                                                        }
                                                        data-toggle="dropdown"
                                                        onClick={
                                                            (e) => {
                                                                if (e.currentTarget.nextSibling.classList.contains('show')) {
                                                                    e.currentTarget.nextSibling.classList.remove('show')
                                                                    e.currentTarget.nextSibling.classList.remove('hide')
                                                                } else {
                                                                    var elems = document.querySelectorAll(".dropdown.show");
                                                                    [].forEach.call(elems, function (el) {
                                                                        el.classList.remove("show");
                                                                        el.classList.add("hide");
                                                                    });
                                                                    e.currentTarget.nextSibling.classList.add('show')
                                                                }
                                                            }
                                                        }
                                                    >{menu.title}<span className="arrow"></span></a>
                                                    <ul aria-labelledby={"child_" + index} className={"dropdown  " + (dropdown == true ? "show" : "")}>
                                                        {
                                                            menu && menu.children && menu.children.map((child, key) => {
                                                                return (
                                                                    child.externalLink == null ?
                                                                        <li key={key}><Link to={child.page ? '/page?slug=' + child.page.slug : '/'}> {child.title} </Link> </li>
                                                                        : <li><Link to={child.externalLink}> {child.title} </Link> </li>
                                                                )
                                                            })
                                                        }
                                                    </ul>
                                                </li>
                                            )
                                        }
                                    })
                                        : null
                                    //: <ul className="menus">
                                    //    <li className="menu-items"><Link to='/'>No Menu Found!  <b>Please Add Menu</b></Link></li>
                                    //</ul>
                                }
                                <li className="GSABanner"><Link to="http://www.gsaelibrary.gsa.gov/ElibMain/contractorInfo.do?contractNumber=GS-10F-0206R&contractorName=TRAILBOSS+ENTERPRISES%2C+INC.&executeQuery=YES" target="_blank"><img src={process.env.REACT_APP_PUBLIC_URL + '/assets/images/gsa_advantage.png'} /></Link></li>
                                
                            </ul>
                        </nav>
                    </div>
                </div>
            </div>
        </>
    )
}

export default memo(Header);